import React from "react";

const defaultPS =
  "В расчет данного показателя берутся последние известные посты за выбранный период.";
//
const BloggersTooltipLayout = ({ children, PS = defaultPS }) => {
  return (
    <>
      <b>{children}</b>
      <br />
      {PS}
    </>
  );
};

export default BloggersTooltipLayout;
